{
  "name": "02 TNT",
  "title": "TNTBlobs",
  "description": "TNTUpgradeDescription1",
  "stat": 6,
  "lockFlag": 22
}